const cards = [
  {
    icon: 'ri-fire-fill',
    color: 'text-accent-400',
    bgColor: 'bg-accent-500/10',
    title: '热门推荐',
    desc: '根据全网热度与观影趋势，每日精选最受欢迎的影片，让你不错过任何一部现象级电影。',
    stat: '实时更新',
  },
  {
    icon: 'ri-star-fill',
    color: 'text-primary-400',
    bgColor: 'bg-primary-500/10',
    title: '高分佳作',
    desc: 'IMDb和豆瓣双平台8分以上的口碑力作，从影史经典到当代杰作，品质保证。',
    stat: '1000+部',
  },
  {
    icon: 'ri-flashlight-fill',
    color: 'text-accent-400',
    bgColor: 'bg-accent-500/10',
    title: '新片速递',
    desc: '紧跟全球上映节奏，第一时间为您呈现最新上线的电影资源，永远走在观影前沿。',
    stat: '每日更新',
  },
  {
    icon: 'ri-emotion-laugh-fill',
    color: 'text-primary-400',
    bgColor: 'bg-primary-500/10',
    title: '喜剧天地',
    desc: '无论国产幽默还是欧美喜剧，让你在笑声中忘记烦恼，快乐就是这么简单。',
    stat: '500+部',
  },
  {
    icon: 'ri-knife-fill',
    color: 'text-accent-400',
    bgColor: 'bg-accent-500/10',
    title: '动作猛片',
    desc: '枪战、格斗、追车、爆炸——肾上腺素飙升的硬核动作体验，点燃你的每一个细胞。',
    stat: '800+部',
  },
  {
    icon: 'ri-planet-fill',
    color: 'text-primary-400',
    bgColor: 'bg-primary-500/10',
    title: '科幻世界',
    desc: '浩瀚宇宙、人工智能、未来世界，想象力的边界在此无限延伸，开启科幻之旅。',
    stat: '600+部',
  },
  {
    icon: 'ri-heart-pulse-fill',
    color: 'text-accent-400',
    bgColor: 'bg-accent-500/10',
    title: '恐怖惊悚',
    desc: '从心理悬疑到超自然恐怖，精心挑选让你脊背发凉的惊悚佳片，胆大者来挑战。',
    stat: '400+部',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-300 bg-primary-500/10 rounded-full mb-4">
            热门分类
          </span>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-50 mb-3">
            热门影片分类
          </h2>
          <p className="text-sm md:text-base text-foreground-400 max-w-[560px] mx-auto">
            七大热门分类，覆盖你最爱的每种电影类型，轻松找到心仪好片
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {cards.slice(0, 4).map((card, idx) => (
            <div
              key={idx}
              className="group rounded-xl bg-background-200/70 border border-background-300/40 p-5 md:p-6 cursor-pointer transition-all duration-300 hover:border-accent-500/25 hover:bg-background-200/90"
            >
              <div className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl ${card.bgColor} mb-4`}>
                <i className={`${card.icon} ${card.color} text-lg md:text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-100 mb-2">{card.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-2">
                {card.desc}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-500">{card.stat}</span>
                <span className={`${card.color} opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-xs flex items-center gap-1`}>
                  浏览 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5 mt-4 md:mt-5">
          {cards.slice(4).map((card, idx) => (
            <div
              key={idx}
              className="group rounded-xl bg-background-200/70 border border-background-300/40 p-5 md:p-6 cursor-pointer transition-all duration-300 hover:border-accent-500/25 hover:bg-background-200/90"
            >
              <div className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl ${card.bgColor} mb-4`}>
                <i className={`${card.icon} ${card.color} text-lg md:text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-100 mb-2">{card.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-2">
                {card.desc}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-500">{card.stat}</span>
                <span className={`${card.color} opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-xs flex items-center gap-1`}>
                  浏览 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}